import { z } from 'zod';

// Where a build marker came from. 'manual' covers everything created via
// the portal; 'system' is reserved for future auto-update integrations
// (Steam / Itch webhooks). Keeping the column on day one means those
// integrations can land without a schema change.
export const BuildMarkerOriginSchema = z.enum(['manual', 'system']);
export type BuildMarkerOrigin = z.infer<typeof BuildMarkerOriginSchema>;

export const BuildMarkerSchema = z.object({
  id: z.string().uuid(),
  gameId: z.string().uuid(),
  // Free-form name the dev gave the build (`v0.4.2`, `firelands-alpha-3`).
  // Not unique per game.
  label: z.string().min(1),
  // Per-destination version metadata. Manual creates default to `label`;
  // future integrations populate this with platform-specific version codes.
  version: z.string().min(1),
  // Foreign key to public.game_dev_stages. The stage's display label /
  // colour / semantic tier are looked up at render time.
  stageId: z.string().uuid(),
  // When the dev archived the marker. Archived markers stay referenced by
  // Issues and Pool records but are hidden from default lists.
  archivedAt: z.string().datetime({ offset: true }).nullable(),
  origin: BuildMarkerOriginSchema,
  createdByUserId: z.string().uuid().nullable(),
  notes: z.string().nullable(),
  releasedAt: z.string().datetime({ offset: true }).nullable(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type BuildMarker = z.infer<typeof BuildMarkerSchema>;

export const BuildMarkerStageTransitionSchema = z.object({
  id: z.string().uuid(),
  buildMarkerId: z.string().uuid(),
  fromStageId: z.string().uuid().nullable(),
  toStageId: z.string().uuid(),
  changedByUserId: z.string().uuid().nullable(),
  reason: z.string().nullable(),
  changedAt: z.string().datetime({ offset: true }),
});
export type BuildMarkerStageTransition = z.infer<typeof BuildMarkerStageTransitionSchema>;
